var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab } from '@mui/material';
import { useRequest } from '../../../hooks/requestHook';
import { roaster as api } from '../../../api';
import PageLayout from '../../atoms/PageLayout';
import { useParams, useNavigate } from 'react-router-dom';
import ProfileContent from './ProfileContent';
import OrdersContent from './OrdersContent';
import SampleOrdersContent from './SampleOrdersContent';
import PreOrderRequestContent from './PreOrderRequestContent';
import AddressList from '../../organisms/RoasterAddress/AddressList';
var AdminRoasterDetailPage = function (_a) {
    var tab = _a.tab;
    var _b = useParams().id, id = _b === void 0 ? '' : _b;
    var t = useTranslation().t;
    var _c = React.useState(), roaster = _c[0], setRoaster = _c[1];
    var _d = React.useState(0), reloadCount = _d[0], setReloadCount = _d[1];
    var getRoaster = useRequest(api.get);
    var navigate = useNavigate();
    var handleUpdate = React.useCallback(function (nextRoaster) {
        setRoaster(nextRoaster);
    }, []);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getRoaster(id)];
                    case 1:
                        response = _a.sent();
                        if (canceled || !response)
                            return [2 /*return*/];
                        setRoaster(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [id, getRoaster, reloadCount]);
    var reload = React.useCallback(function () { return setReloadCount(function (oldCount) { return oldCount + 1; }); }, []);
    if (!roaster)
        return null;
    return (React.createElement(PageLayout, { title: t('pages.adminRoasterDetail.title', {
            roaster: t('fullname', roaster),
        }), backLinkTo: "/admin/roasters" },
        React.createElement(Tabs, { value: tab },
            React.createElement(Tab, { value: "profile", label: t('pages.editProfile.title'), onClick: function () { return navigate("/admin/roasters/".concat(roaster.id, "/profile")); } }),
            React.createElement(Tab, { value: "delivery_addresses", label: t('pages.roasterAddresses.deliveryAddresses'), onClick: function () {
                    return navigate("/admin/roasters/".concat(roaster.id, "/delivery_addresses"));
                } }),
            React.createElement(Tab, { value: "billing_addresses", label: t('pages.roasterAddresses.billingAddresses'), onClick: function () {
                    return navigate("/admin/roasters/".concat(roaster.id, "/billing_addresses"));
                } }),
            React.createElement(Tab, { value: "orders", label: t('pages.ordersPage.title'), onClick: function () { return navigate("/admin/roasters/".concat(roaster.id, "/orders")); } }),
            React.createElement(Tab, { value: "sample_orders", label: t('pages.sampleOrdersPage.title'), onClick: function () {
                    return navigate("/admin/roasters/".concat(roaster.id, "/sample_orders"));
                } }),
            React.createElement(Tab, { value: "pre_order_requests", label: t('pages.preOrderRequest.title'), onClick: function () {
                    return navigate("/admin/roasters/".concat(roaster.id, "/pre_order_requests"));
                } })),
        tab === 'profile' && (React.createElement(ProfileContent, { roaster: roaster, onUpdate: handleUpdate })),
        tab === 'orders' && React.createElement(OrdersContent, { roaster: roaster }),
        tab === 'sample_orders' && React.createElement(SampleOrdersContent, { roaster: roaster }),
        tab === 'pre_order_requests' && (React.createElement(PreOrderRequestContent, { roaster: roaster })),
        tab === 'billing_addresses' && (React.createElement(AddressList, { type: "billing", roaster: roaster, reloadRoaster: reload })),
        tab === 'delivery_addresses' && (React.createElement(AddressList, { type: "delivery", roaster: roaster, reloadRoaster: reload }))));
};
export default AdminRoasterDetailPage;
